const state = () => ({
  DataLocationDormitory: [],
});
/* ========== getters ========== */
const getters = {
  _getDataLocationDormitory: (state) => {
    return state.DataLocationDormitory;
  },
};
/* ========== actions ========== */
const actions = {
  async GET_Location_Dormitory({ commit }) {
    try {
      const response = await window.Axios.get(
        `${window.api}get/list_Location_Dormitory/`
      );
      await commit("GET_Location_Dormitory", response.data);
    } catch (error) {
      console.error(error);
    }
  },
};

/* ========== mutations ========== */
const mutations = {
  GET_Location_Dormitory(state, payload) {
    state.DataLocationDormitory = payload;
  },
};

/* ========== Export ========== */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
